import io from 'socket.io-client';
import { socketConfigs } from '../constants/socketConfigs';
import { loadUserProfile } from './apiUtils';
import packageJson from '../../package.json';

let socketDispatch = null;
let socketNewcc = null;
const PATH = '/socket.io-v4/';
const PATH_SIGNUP = '/socket.io-v4/';
export const socketNewccApi = {
  on(event, callback) {
    if (socketNewcc) {
      socketNewcc.on(event, (data) => {
        callback(data);
      });
    }
  },
  emit(event, data, callback) {
    if (socketNewcc) {
      socketNewcc.emit(event, data, (data) => {
        callback(data);
      });
    }
  },
  remove(event) {
    if (socketNewcc) {
      socketNewcc.removeListener(event);
    }
  },
  close() {
    if (socketNewcc) {
      socketNewcc.disconnect();
    }
  },
};

function socketNewccAuth(params, connectedCallback, disconnectCallback, reconnect_attemptCallback, reconnectCallback) {
  if (!socketNewcc) {
    socketNewcc = io(process.env.REACT_APP_SOCKET_LOCAL, {
      query: {
        platform: 'web - newcc',
        version: packageJson.version,
      },
      transports: ['websocket'],
    });
    socketNewcc.on('connect', () => {
      const user = loadUserProfile();
      socketNewcc.emit('onboarding-room:join', {
        token: user.token,
        userId: params.userId,
      });
    });
    socketNewcc.on('onboarding-room:join-success', (payload) => {
      connectedCallback(payload);
    });
    socketNewcc.on('onboarding-room:join-error', (payload) => {
      disconnectCallback(payload);
    });
  }
  socketNewcc.on('disconnect', (attempt) => {
    disconnectCallback();
  });
  socketNewcc.on('reconnect_attempt', (attempt) => {
    reconnect_attemptCallback();
  });
  socketNewcc.on('reconnect', (attempt) => {
    reconnectCallback(attempt);
  });
  socketNewcc.on('connect_error', (error) => {
    console.log('SocketNewcc.connect_error', error);
  });
  socketNewcc.on('connect_timeout', (error) => {
    console.log('SocketNewcc.connect_timeout', error);
  });
  socketNewcc.on('reconnect_error', (error) => {
    console.log('SocketNewcc.reconnect_error', error);
  });
  socketNewcc.on('reconnect_failed', (error) => {
    console.log('SocketNewcc.reconnect_failed', error);
  });
}

export const socketDispatchApi = {
  on(event, callback) {
    if (socketDispatch) {
      socketDispatch.on(event, (data) => {
        callback(data);
      });
    }
  },

  emit(event, data, callback) {
    if (socketDispatch) {
      socketDispatch.emit(event, data, (data) => {
        callback(data);
      });
    }
  },
  remove(event) {
    if (socketDispatch) {
      socketDispatch.removeListener(event);
    }
  },
  close() {
    if (socketDispatch) {
      socketDispatch.disconnect();
    }
  },
};

let isFirstConnect = true;

function socketDispatchAuth(
  fleetid,
  connectedCallback,
  disconnectCallback,
  reconnect_attemptCallback,
  reconnectCallback
) {
  if (!socketDispatch) {
    socketDispatch = io(socketConfigs.socketDispatchServer, {
      query: {
        platform: 'web - newcc',
        version: packageJson.version
      },
      transports: ['websocket'],
      path: PATH
    });
    socketDispatch.on('connect', () => {
      const user = loadUserProfile();
      socketDispatch.emit(socketConfigs.send.ccLiteLogin, {
        token: user.token,
        fleetId: fleetid,
      });
    });
    socketDispatch.on(socketConfigs.send.ccLiteLogin, (payload) => {
      connectedCallback(payload);
      if(!isFirstConnect) reconnectCallback()
      else isFirstConnect = false;

    });
    socketDispatch.on('disconnect', (attempt) => {
      if (socketConfigs.socketDebug) console.log('SocketDispatch.disconnect', attempt);
      disconnectCallback();
    });
    socketDispatch.on('reconnect_attempt', (attempt) => {
      if (socketConfigs.socketDebug) console.log('SocketDispatch.reconnect_attempt', attempt);
      reconnect_attemptCallback();
    });
    socketDispatch.on('reconnect', (attempt) => {
      if (socketConfigs.socketDebug) console.log('SocketDispatch.reconnect', attempt);
      if (typeof reconnectCallback === 'function') reconnectCallback(attempt);
    });

    if (socketConfigs.socketDebug) {
      socketDispatch.on('connect_error', (error) => {
        console.log('SocketDispatch.connect_error', error);
      });
      socketDispatch.on('connect_timeout', (error) => {
        console.log('SocketDispatch.connect_timeout', error);
      });
      socketDispatch.on('reconnect_error', (error) => {
        console.log('SocketDispatch.reconnect_error', error);
      });
      socketDispatch.on('reconnect_failed', (error) => {
        console.log('SocketDispatch.reconnect_failed', error);
      });
    }
  }
}

export function socketDispatchAuthAsync(fleetid, reconnectCallback) {
  return new Promise((resolve, reject) => {
    socketDispatchAuth(
      fleetid,
      (payload) => resolve(payload),
      () => reject(new Error('Socket disconnected')),
      () => {},
      reconnectCallback
    );
  });
}

export function socketNewccAuthAsync(params, reconnectCallback) {
  return new Promise((resolve, reject) => {
    socketNewccAuth(
      params,
      (payload) => resolve(payload),
      () => {
        console.error('SocketNewcc disconnected')
        return reject()
      },
      () => {},
      reconnectCallback
    );
  });
}